export default __webpack_public_path__ + "static/RC-horiz-1e83e5bc7b9a82067600f62c8b3b3ae7.svg";